import { environment } from "./environment";

export const config = {
  apiUrl: environment.apiUrl,
  moyasarPublishableKey: environment.moyasarPublishableKey,
  samsungPayServiceId: (environment as any).samsungPayServiceId,
  applePayLabel: (environment as any).applePayLabel
};